import Keycloak from 'keycloak-js';
import Vue from 'vue';

const prdEnv = process.env.NODE_ENV === 'production',
  jsonPath = prdEnv ? `${window.location.origin}/keycloak.json` : `${window.location.origin}/static/keycloak.json`,
  keycloak = new Keycloak(jsonPath);

const setSessionData = (key, data) => {
  sessionStorage.setItem(key, data);
};

const sessionListeners = [];

const notifySessionExpired = () => {
  if (sessionListeners.length === 0) {
    keycloak.logout({ redirectUri: window.location.origin });
  } else {
    sessionListeners.forEach((listener) => listener.onSessionExpired());
  }
};

const con = console;

const refreshToken = () => keycloak.updateToken(-1)
  .then(() => Promise.resolve())
  .catch(() => Promise.reject());

const onResponse = (response) => {
  if (response.status === 401) {
    con.log('Sessão expirada mediante resposta 401.');
    notifySessionExpired();
  }
  return response;
};

const isRefreshTokenExpired = () => {
  const tenSeconds = 10 * 1000,
    now = new Date().getTime(),
    timeSkew = keycloak.timeSkew * 1000,
    refreshDate = new Date(keycloak.refreshTokenParsed.exp * 1000).getTime();

  let expiresIn = refreshDate;
  expiresIn += timeSkew;
  expiresIn -= now;
  expiresIn -= tenSeconds;

  return expiresIn < 0;
};

const setHeaders = (request) => {
  request.headers.set('Authorization', `Bearer ${keycloak.token}`);
  request.headers.set('Accept', 'application/json');
  request.headers.set('Content-type', 'application/json');
};

const isTokenExpired = () => keycloak.isTokenExpired(10);

export const validAndRefreshToken = () => {
  if (isTokenExpired()) {
    if (!isRefreshTokenExpired()) {
      return refreshToken().then(() => {
        setSessionData('token', keycloak.token);
      });
    }
    con.log('Sessão expirada mediante expiração do token de refresh.');
    notifySessionExpired();
    Promise.reject();
  }
  return Promise.resolve();
};

export const authKeycloak = {
  init() {
    return new Promise((resolve, reject) => {
      keycloak.init({
        onLoad: 'check-sso',
        timeSkew: 0,
        checkLoginIframe: false,
      })
        .then((authenticated) => {
          if (authenticated) {
            setSessionData('token', keycloak.token);
            setSessionData('idToken', keycloak.idToken);
            setSessionData('refreshToken', keycloak.refreshToken);
          }
          resolve(authenticated);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  login() {
    keycloak.login({ redirectUri: window.location.origin });
  },
  doLogout() {
    localStorage.removeItem('xTenantId');
    keycloak.logout({ redirectUri: window.location.origin });
  },
  createInterceptors() {
    Vue.http.interceptors.push((request) => {
      if (!isTokenExpired()) {
        setHeaders(request);
      } else if (!isRefreshTokenExpired()) {
        const refreshTokenPromise = new Promise((resolve, reject) => refreshToken()
          .then(() => resolve())
          .catch(() => {
            con.log('Sessão expirada mediante expiração do token de refresh.');
            notifySessionExpired();
            reject();
          }));
        return refreshTokenPromise.then(() => {
          setHeaders(request);
          return Vue.http(request);
        });
      } else {
        con.log('Sessão expirada mediante expiração do token de refresh.');
        notifySessionExpired();
      }
      return onResponse;
    });
  },
  isTokenExpired() {
    return isTokenExpired();
  },
  refreshToken() {
    return new Promise((resolve) => {
      refreshToken()
        .then(resolve)
        .catch(() => {
          notifySessionExpired();
        });
    });
  },
  registerSessionListener(listener) {
    if (listener.onSessionExpired) sessionListeners.push(listener);
  },
};

window.keycloak = keycloak;

const plugin = () => {
  Vue.prototype.$authKeycloak = authKeycloak;
  // You might want to expose your authKeycloak object methods on the Vue prototype too
  Vue.prototype.$auth = keycloak;
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

export default plugin;
